import firebase from "firebase/app";
import "firebase/messaging";

let messaging;

try {
    const { apiKey, authDomain, projectId, messagingSenderId, publicVapidKey } = window.firebaseConfig;
    const app =
        firebase.apps.length > 0
            ? firebase.apps[0]
            : firebase.initializeApp({ apiKey, authDomain, projectId, messagingSenderId });
    const swURI = `/rtm-sw.js?apiKey=${apiKey}&authDomain=${authDomain}&projectId=${projectId}&messagingSenderId=${messagingSenderId}`; // eslint-disable-line max-len

    messaging = app.messaging();
    messaging.usePublicVapidKey(publicVapidKey);
    navigator.serviceWorker.register(swURI).then(registration => {
        messaging.useServiceWorker(registration);
    });
} catch (exception) {
    messaging = {
        requestPermission: () =>
            new Promise(resolve => {
                resolve();
            }),
        getToken: () =>
            new Promise(resolve => {
                resolve();
            }),
    };
}

export default messaging;
